module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1794153"
    }
  }, [_c('b', [_vm._v("CREAM OF ASPARAGUS SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1794653"
    }
  }, [_c('b', [_c('i', [_vm._v("For the most flavor, choose the thickest asparagus you can find for this creamy soup. If you wish, garnish each serving with a sprinkling of snipped fresh chives or chopped tarragon or parsley.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1796253"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes Cook: 25 to 30 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1796853"
    }
  }, [_vm._v("2 tablespoons butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1797153"
    }
  }, [_vm._v("1 medium onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1797453"
    }
  }, [_vm._v("12 ounces asparagus, trimmed and cut into "), _c('br'), _vm._v(" 1-inch pieces (3 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1798053"
    }
  }, [_vm._v("3 tablespoons all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1798353"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1799353"
    }
  }, [_vm._v("⅛ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1800253"
    }
  }, [_vm._v("1 can (14½ ounces) chicken or vegetable broth or "), _c('br'), _vm._v("1¾ cups Chicken Broth or Vegetable Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1802953"
    }
  }, [_vm._v("1 cup half-and-half or light cream")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1803453"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 3-quart saucepan, melt butter over medium heat; add onion and cook, stirring frequently, until tender and golden, about 10 minutes. Add asparagus; cook 1 minute.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1805153"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Stir in flour, salt, and pepper until blended. Gradually stir in broth; heat to boiling, stirring constantly. Reduce heat; cover and simmer until asparagus is tender, 5 to 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1807253"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Spoon half of mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour into bowl. Repeat with remaining mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1809153"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Return puree to saucepan; stir in half-and-half. Heat through (do not boil). Serve soup hot, or cover and refrigerate to serve chilled later. If chilled soup is too thick, stir in some milk. Makes about 5 cups or 4 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1811553"
    }
  }, [_vm._v("Each serving: About 194 calories, 6g protein, 14g carbohydrate, 14g total fat (8g saturated), 38mg cholesterol, 657mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1814253"
    }
  }, [_c('b', [_vm._v("CREAM OF CAULIFLOWER "), _c('br'), _vm._v(" OR BROCCOLI SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1815053"
    }
  }, [_vm._v("Prepare as directed above but substitute "), _c('b', [_vm._v("3 cups small cauliflower or broccoli flowerets")]), _vm._v(" for asparagus. Use "), _c('b', [_vm._v("1¼ cups half-and-half or light cream")]), _vm._v(" and add "), _c('b', [_vm._v("dash of ground red pepper.")]), _vm._v(" If desired, stir in "), _c('b', [_vm._v("4 ounces sharp Cheddar cheese,")]), _vm._v(" shredded (1 cup) and "), _c('b', [_vm._v("½ teaspoon Dijon mustard")]), _vm._v(" when heating through. Makes about 5 cups or 4 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1821153"
    }
  }, [_c('b', [_vm._v("CREAM OF MUSHROOM SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1821753"
    }
  }, [_vm._v("Prepare as directed above but substitute "), _c('b', [_vm._v("1 pound mushrooms,")]), _vm._v(" trimmed and sliced for asparagus. Makes about 4½ cups or 4 first-course servings.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381c6efd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c48_r1.vue
// module id = 210
// module chunks = 0